import { render, staticRenderFns } from "./MenuPantalla.vue?vue&type=template&id=01789b06&scoped=true"
import script from "./MenuPantalla.vue?vue&type=script&lang=js"
export * from "./MenuPantalla.vue?vue&type=script&lang=js"
import style0 from "./MenuPantalla.vue?vue&type=style&index=0&id=01789b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01789b06",
  null
  
)

export default component.exports